import React from 'react'
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { useState } from 'react';
function EditAttribute() {
  const { id } = useParams();
  const [attributename, setAttributename] = useState('');
  const [attributetype, setAttributeType] = useState('');
  const [code, setCode] = useState('');
  const [attributegroup, setAttributeGroup] = useState('');
  const [attributetab, setAttributeTab] = useState('');
  const [defaultscope, setDefaultScope] = useState('');
  const [defaultchannel, setDefaultChannel] = useState('');
  const sendData = async (e) => {
    try {
      e.preventDefault();
      const formdata = new FormData();
      formdata.append('attributename', attributename);
      formdata.append('attributetype', attributetype);
      formdata.append('code', code);
      formdata.append('attributegroup', attributegroup);
      formdata.append('attributetab', attributetab);
      formdata.append('defaultscope', defaultscope);
      formdata.append('defaultchannel', defaultchannel);
      const response = await axios.put(process.env.REACT_APP_API_URL+`/api/brands/${id}`, formdata)
      console.log(response);
    }
    catch (error) {
      console.error(error);
    }
  }
  return (
    <>
      <div >
        <p className='m-6'>Edit Attribute</p>
        <form class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4" onSubmit={sendData}>
          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="groupname">
              Attribute Name
            </label>
            <input class="shadow appearance-none border rounded w-96 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="groupname" type="text" placeholder="Attribute Name"
              onChange={(e) => setAttributename(e.target.value)}
              autoComplete='attributename'
            />
          </div>
          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="AttributeType">
              Attribute Type
            </label>
            <input class="shadow appearance-none border rounded w-96 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="code" type="text" placeholder="Attribute Type"
              onChange={(e) => setAttributeType(e.target.value)}
              autoComplete='attributetype'
            />
          </div>
          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="code">
              Code
            </label>
            <input class="shadow appearance-none border rounded w-96 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="code" type="text" placeholder="Code"
              onChange={(e) => setCode(e.target.value)}
              autoComplete='code'
            />
          </div>
          <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="attributegroup">
              Attribute Group
            </label>
            <input class="shadow appearance-none border rounded w-96 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="sortorder" type="text" placeholder="Attribute Group"
              onChange={(e) => setAttributeGroup(e.target.value)}
              autoComplete='attributegroup'/>

          </div>
          <div class="mb-4">
            <label class="block text
            -gray-700 text-sm font-bold mb-2" for="attributetab">
              Attribute Tab
            </label>
            <input class="shadow appearance-none border rounded w-96 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="sortorder" type="text" placeholder="Attribute Tab"

              onChange={(e) => setAttributeTab(e.target.value)}
              autoComplete='attributetab'
            />
          </div>
          <div class="mb-4">
            <label class="block text
            -gray-700 text-sm font-bold mb-2" for="defaultscope">
              Default Scope
            </label>

            <input class="shadow appearance-none border rounded w-96 py-2 px-3 text-gray-700 leading-tight focus:outline-none " id="sortorder" type="text" placeholder="Default Scope"

              onChange={(e) => setDefaultScope(e.target.value)}
              autoComplete='defaultscope'
            />
          </div>
          <div class="mb-4">
            <label class="block text
            -gray-700 text-sm font-bold mb-2" for="defaultchannel">
              Default Channel
            </label>
            <input class="shadow appearance-none border rounded w-96 py-2 px-3 text-gray-700 leading-tight focus:outline-none " id="sortorder" type="text" placeholder="Default Channel"

              onChange={(e) => setDefaultChannel(e.target.value)}
              autoComplete='defaultchannel'
            />
          </div>
           <div class="flex items-center justify-between">
            <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="submit">
              Edit
            </button>
          </div> 

              </form>
              </div>
          </>
          )
  }
export default EditAttribute